module.exports = __webpack_public_path__ + "img/Encashment.dbfe827a.svg";